import React, { useEffect, useState, Fragment } from "react";
import Input from "../../../CoreComponent/Input";
import ReactSelect from "react-select";
import PhoneNumberInput from "../../../CoreComponent/PhoneNumber";
import toast from "react-hot-toast";
import axios from "axios";
import SVG from "react-inlinesvg";
import deleteIcon from "../../../icons/deleteIcon.svg";
import {
  saveToLocalStorage,
  getFromLocalStorage,
} from "../../../common/localStorage";
import { useTripsStepper } from "../StepperContext";
import "./style.scss";
import DateInput from "../../../CoreComponent/Date";
import { Button, Grid } from "@mui/material";

const ParticipantTripForm = () => {
  const [countries, setCountries] = useState([]);
  const { currentStep, completeStep, noViewAccommodation } = useTripsStepper();

  const initialValue = {
    id: Date.now(),
    name: "",
    nationality: "",
    phone_number: "",
    whatsapp_number: "",
    is_companion: true,
    include_accommodation: false,
    accommodation_stars: "",
    nights_count: "",
    check_in_date: "",
    check_out_date: "",
  };

  const [participants, setParticipants] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get("https://eventscons.com/eventbackendnew/api/countries");
        const apiData = response.data.data;

        const countryOptions = apiData.map((country) => ({
          value: country.name,
          label: country.name,
          flag_url: country.flag_url,
        }));

        setCountries(countryOptions);
      } catch (error) {
        console.error("❌ API Error:", error);
        toast.error("loading Countries");
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    const data = getFromLocalStorage("participants");
    if (data && Array.isArray(data) && data.length > 0) {
      setParticipants(data);
    }
  }, []);

  const formatOptionLabel = ({ label, flag_url }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <img
        src={flag_url}
        alt={label}
        style={{ width: "25px", marginRight: "10px", borderRadius: "2px" }}
      />
      <span>{label}</span>
    </div>
  );

  const addParticipant = () => {
    setParticipants((prev) => [
      ...prev,
      { ...initialValue, id: Date.now() + Math.random() },
    ]);
  };

 const deleteParticipant = (id) => {
  setParticipants(participants.filter((p) => p.id !== id));
};

  const handleInputChange = (id, key, value) => {
    setParticipants(
      participants.map((p) => (p.id === id ? { ...p, [key]: value } : p))
    );
  };

const handleSubmit = () => {
  toast.success("Data updated successfully!");
  completeStep(currentStep);
  saveToLocalStorage("participants", participants);
};

  const hasParticipants = participants.length > 0;

  return (
    <div className="participant-form-container">
      <div style={{ marginBottom: "20px", textAlign: "right" }}>
        <Button
          variant="outlined"
          onClick={addParticipant}
          sx={{ color: "#cc0000", borderColor: "#cc0000" }}
        >
          + Add Participation
        </Button>
      </div>

      {hasParticipants && (
        <Grid container spacing={3}>
          {participants.map((participant, index) => {
            const selectedCountry = countries.find(
              (c) => c.value === participant.nationality
            );

            return (
              <Grid item xs={12} key={participant.id}>
                <div
                  style={{
                    padding: "20px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() => deleteParticipant(participant.id)}
                  >
                    <SVG src={deleteIcon} width={20} />
                  </div>

                  <h4 style={{ marginTop: 0 }}>Participant {index + 1}</h4>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Input
                        label="Full Name"
                        placeholder="Enter name"
                        inputValue={participant.name}
                        setInputValue={(val) =>
                          handleInputChange(participant.id, "name", val)
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <label style={{ display: "block", marginBottom: "8px", fontSize: "13px" }}>
                        Nationality
                      </label>
                      <ReactSelect
                        options={countries}
                        value={selectedCountry}
                        onChange={(opt) =>
                          handleInputChange(participant.id, "nationality", opt?.value || "")
                        }
                        formatOptionLabel={formatOptionLabel}
                        placeholder="Select Country"
                        styles={{
                          control: (base) => ({
                            ...base,
                            height: "30px",
                            borderRadius: "3px",
                            fontSize: "13px",
                          }),
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <PhoneNumberInput
                        label="Phone Number"
                        phone={participant.phone_number}
                        setPhone={(val) =>
                          handleInputChange(participant.id, "phone_number", val)
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <PhoneNumberInput
                        label="WhatsApp Number"
                        phone={participant.whatsapp_number}
                        setPhone={(val) =>
                          handleInputChange(participant.id, "whatsapp_number", val)
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <DateInput
                        label="Start Date"
                        inputValue={participant.check_in_date}
                        setInputValue={(val) =>
                          handleInputChange(participant.id, "check_in_date", val)
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <DateInput
                        label="End Date"
                        inputValue={participant.check_out_date}
                        setInputValue={(val) =>
                          handleInputChange(participant.id, "check_out_date", val)
                        }
                      />
                    </Grid>

                    {!noViewAccommodation && (
                      <Fragment>
                        <Grid item xs={12} sm={6}>
                          <Input
                            label="Accommodation Stars"
                            inputValue={participant.accommodation_stars}
                            setInputValue={(val) =>
                              handleInputChange(
                                participant.id,
                                "accommodation_stars",
                                val
                              )
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Input
                            label="Nights Count"
                            inputValue={participant.nights_count}
                            setInputValue={(val) =>
                              handleInputChange(
                                participant.id,
                                "nights_count",
                                val
                              )
                            }
                          />
                        </Grid>
                      </Fragment>
                    )}
                  </Grid>
                </div>
              </Grid>
            );
          })}
        </Grid>
      )}

      <div style={{ marginTop: "30px" }}>
        <Button
          variant="contained"
          onClick={handleSubmit}
          fullWidth
          sx={{ backgroundColor: "#cc0000", height: "50px" }}
        >
          Next Step
        </Button>
      </div>
    </div>
  );
};

export default ParticipantTripForm;